import ValueObject from './ValueObject';

export default class LocationId extends ValueObject {
  equals(other) {
    if (!(other instanceof LocationId)) {
      return false;
    }

    return super.equals(other);
  }

  static fromJSON(json) {
    return new LocationId(json);
  }
}
